module.exports = __webpack_public_path__ + "static/bentonsans-book-webfont-1e7888ffe1d3f73b2d8de60ca7b3788c.woff2";